// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3seQs","rootCenter":"LoadMoreObserver_rootCenter__1BNuC","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__PjWPw"};